import React from 'react';
import ecLandingArrowImg from '../../../src/component/enterprise-client/assets/fly 1.svg';

function ECLandingSec1() {
    return (
        <>
            <div className="xl:paddingTop">
                <span className="xl:text-heading1 font-semibold">
                    Discover <span className='text-primaryColor'>Creators.<br></br> Maximize ROI.</span> Go to Market.
                </span>
                <p className="xl: text-base xl:pt-10 xl:leading-lineHeightBodyText">
                    Find your brand's untapped potential by leveraging the influence of over 500K+ geographically targeted creators. Amplify your ROI and achieve unrivalled market dominance. Start your first campaign INR 3000* Only.
                </p>
                <div className="xl:flex xl:justify-end xl:w-rocketWidth">
                    <img className='ec-landing-sec1-heading-img' src={ecLandingArrowImg} alt="ecLandingArrowImg" />
                </div>
            </div>
        </>
    )
}

export default ECLandingSec1
